import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Self, input } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';

import { FormControlPipe } from '@shared/pipe';
import { IFormCustomClass } from '@data/schema';

@Component({
    selector: 'app-text-area-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormControlPipe],
    templateUrl: './text-area-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextAreaInputComponent implements ControlValueAccessor {
    label = input.required<string>();
    secondaryLabel = input<string>();
    placeholder = input<string>();
    inputRequiredIndicatorEnabled = input<boolean>(false);
    rows = input<number>(3);
    testAutomationSelectorName = input<string>();
    customClasses = input<IFormCustomClass>({
        formGroup: 'mb-3',
        label: 'form-label fw-medium mb-1',
        input: 'form-control',
        secondaryLabel: 'form-text',
    });

    constructor(@Self() public ngControl: NgControl) {
        this.ngControl.valueAccessor = this;
    }

    writeValue(_obj: any): void {}
    registerOnChange(_fn: any): void {}
    registerOnTouched(_fn: any): void {}
}
